import type { SessionBasedSampler, SplunkOtelWebType } from '@splunk/otel-web';
import { browser, version } from '$app/environment';
import { env } from '$env/dynamic/public';
import { isNogarnish } from '$lib/utils/nogarnish';
import { name } from '../../../../../package.json';

const { PUBLIC_ENABLE_RUM, PUBLIC_ENVIRONMENT, PUBLIC_RUM_TOKEN, PUBLIC_RUM_RATIO } = env;

const rumEnabled = PUBLIC_ENABLE_RUM === 'true';

export async function initializeSplunkRum() {
	useSplunkRum((SplunkRum, { SessionBasedSampler }) => {
		// TODO : When @splunk/otel-web will upgrade to @opentelemetry/sdk-trace-web@2.x, please remove the pnpm override
		SplunkRum.init({
			realm: 'eu0',
			rumAccessToken: PUBLIC_RUM_TOKEN,
			tracer: {
				// Sample rum to include only the ratio of traces
				// This is session based so we will always have all info for a given user
				sampler: new SessionBasedSampler({
					ratio: Number(PUBLIC_RUM_RATIO), // Number between 0 and 1
				}),
			},
			version,
			applicationName: name,
			deploymentEnvironment: PUBLIC_ENVIRONMENT,
		});
	});
}

export async function useSplunkRum(callback: (splunkRum: SplunkOtelWebType, options: { SessionBasedSampler: typeof SessionBasedSampler }) => void) {
	const canUseSplunkRum = browser && rumEnabled && !isNogarnish();
	if (!canUseSplunkRum) {
		return;
	}
	const { SplunkRum, SessionBasedSampler } = await import('@splunk/otel-web');

	callback(SplunkRum, { SessionBasedSampler });
}
